// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati?societaId={id}&q={q}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","nome":"string","nComponenti":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli?societaId={id}&q={q}&limit=50',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","descrizioneBase":"string","tipologia":"string","umVendita":{"simbolo":"string"}}],"total":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/sedi/mie?societaId={id}&commerciale=true',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/capitolati/:id',
    requestBody: '{"nome":"string","descrizione":"string","attivo":"boolean","righe":[]}',
    response: '{"success":true,"data":{}}'
  },
  {
    method: 'POST',
    endpoint: '/api/capitolati',
    requestBody: '{"societaId":"number","nome":"string","descrizione":"string","attivo":"boolean","righe":[]}',
    response: '{"success":true,"data":{}}'
  },
  {
    method: 'GET',
    endpoint: '/api/sedi/mie?societaId={id}&commerciale=true',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/capitolati?societaId={id}&sedeId={sedeId}&q={q}&attivo={attivo}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","nome":"string","attivo":"boolean","sedeId":"number","sede":{"id":"number","nome":"string"},"_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/capitolati/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","codice":"string","nome":"string","righe":[]}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/capitolati/:id',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
